
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export function useNursingHomes(countySlug: string | undefined, searchQuery: string, sortBy: string) {
  const { data, isLoading, error } = useQuery({
    queryKey: ['nursing_homes', countySlug, searchQuery, sortBy],
    queryFn: async () => {
      try {
        console.log(`Fetching nursing homes for county: ${countySlug}`);
        
        let query = supabase
          .from('nursing_homes')
          .select('*')
          .eq('county_slug', countySlug);

        if (searchQuery) {
          query = query.ilike('center_name', `%${searchQuery}%`);
        }

        switch (sortBy) {
          case 'name_desc':
            query = query.order('center_name', { ascending: false });
            break;
          case 'established_asc':
            query = query.order('year_established', { ascending: true });
            break;
          case 'established_desc':
            query = query.order('year_established', { ascending: false });
            break;
          case 'capacity_asc':
            query = query.order('max_residents', { ascending: true });
            break;
          case 'capacity_desc':
            query = query.order('max_residents', { ascending: false });
            break;
          default:
            query = query.order('center_name', { ascending: true });
        }

        const { data, error } = await query;

        if (error) {
          console.error('Error fetching nursing homes:', error);
          toast.error("Failed to load nursing homes");
          throw error;
        }

        console.log(`Found ${data?.length} nursing homes for ${countySlug}`);
        console.log('First nursing home sample:', data?.[0]);
        
        return data || [];
      } catch (err) {
        console.error('Error in query function:', err);
        toast.error("Failed to load nursing homes. Please try again later.");
        throw err;
      }
    },
    enabled: !!countySlug,
  });

  return { data: data || [], isLoading, error };
}
